import { EventPlug } from "../adapters/EventAdapter/EventPlug";
import { LocalStoragePlug } from "../adapters/LocalStorageAdapter/LocalStoragePlug";
import { SessionStoragePlug } from "../adapters/LocalStorageAdapter/SessionStoragePlug";
import { NavigationPlug } from "../adapters/NavigationAdapter/NavigationPlug";
import { NotifierPlug } from "../adapters/NotifyAdapter/NotifyPlug";
import { PortResolver } from "../adapters/PortResolver";
import { TranslationPlug } from "../adapters/TranslationAdapter/TranslationPlug";
import { AttentionDayRepository } from "../adapters/WebApiAdapter/AttentionDayRepository";
import { AuthenticationRepository } from "../adapters/WebApiAdapter/AuthenticationRepository";
import { EmployeeAbsenceRepository } from "../adapters/WebApiAdapter/EmployeeAbsenceRepository";
import { EmployeeGroupRepository } from "../adapters/WebApiAdapter/EmployeeGroupRepository";
import { EmployeeRepository } from "../adapters/WebApiAdapter/EmployeeRepository";
import { VersionInfoRepository } from "../adapters/WebApiAdapter/VersionInfoRepository";
import { appDependencies } from "../domain/AppDependencies";
import { appDomain } from "../domain/AppDomain";
import { AlertService } from "../domain/notifications/AlertService";
import { AttentionDayService } from "../domain/attentiondays/AttentionDayService";
import { AuthenticationService } from "../domain/authentication/AuthenticationService";
import { EmployeeAbsenceService } from "../domain/absences/EmployeeAbsenceService";
import { EmployeeGroupService } from "../domain/employeeGroups/EmployeeGroupService";
import { EmployeeService } from '../domain/employees/EmployeeService';
import { ExceptionService } from "../domain/app/ExceptionService";
import { LanguageService } from "../domain/translations/LanguageService";
import { MenuService } from "../domain/appMenu/MenuService";
import { Navigator } from "../domain/navigation/Navigator";
import { NotifyService } from "../domain/notifications/NotifyService";
import { PermissionService } from "../domain/authentication/PermissionService";
import { TranslationService } from "../domain/translations/TranslationService";
import { IEmployeeAbsenceRepository } from "../domain/absences/IEmployeeAbsenceRepository";
import { IEmployeeAbsenceService } from "../domain/absences/IEmployeeAbsenceService";
import { IHandleExceptions } from "../domain/app/IHandleExceptions";
import { ILocalRepository } from "../domain/app/ILocalRepository";
import { IRequestMenuItems } from "../domain/appMenu/IRequestMenuItems";
import { IRequestVersionInfo } from "../domain/appVersion/IRequestVersionInfo";
import { IVersionInfoRepository } from "../domain/appVersion/IVersionInfoRepository";
import { VersionService } from "../domain/appVersion/VersionService";
import { IAttentionDayRepository } from "../domain/attentiondays/IAttentionDayRepository";
import { IAttentionDayService } from "../domain/attentiondays/IAttentionDayService";
import { IAuthenticationRepository } from "../domain/authentication/IAuthenticationRepository";
import { IAuthenticationService } from "../domain/authentication/IAuthenticationService";
import { IEmployeeGroupRepository } from "../domain/employeeGroups/IEmployeeGroupRepository";
import { IEmployeeGroupService } from "../domain/employeeGroups/IEmployeeGroupService";
import { IEmployeeRepository } from "../domain/employees/IEmployeeRepository";
import { IEmployeeService } from "../domain/employees/IEmployeeService";
import { IEventProvider } from "../domain/events/IEventProvider";
import { INavigateTo } from "../domain/navigation/INavigateTo";
import { INavigator } from "../domain/navigation/INavigator";
import { ICanNotify } from "../domain/notifications/ICanNotify";
import { IRequestAlert } from "../domain/notifications/IRequestAlert";
import { IRequestNotify } from "../domain/notifications/IRequestNotify";
import { ICanTranslate } from "../domain/translations/ICanTranslate";
import { IRequestLanguageChange } from "../domain/translations/IRequestLanguageChange";
import { IRequestTranslation } from "../domain/translations/IRequestTranslation";
import { IRequestPermission } from "../domain/users/IRequestPermission";


export class Wiring {
    portResolver: PortResolver;
    constructor() {
        this.portResolver = new PortResolver();
        const instance = this.portResolver.registerInstance.bind(this.portResolver) as <T>(name: string, fn: () => T) => void;
        // primary
        instance<IAuthenticationService>("IAuthenticationService", () => new AuthenticationService());
        instance<IRequestPermission>("IRequestPermission", () => new PermissionService());
        instance<IRequestLanguageChange>("IRequestLanguageChange", () => new LanguageService());
        instance<IHandleExceptions>("IHandleExceptions", () => new ExceptionService());
        instance<INavigator>("INavigator", () => new Navigator());
        instance<IRequestVersionInfo>("IRequestVersionInfo", () => new VersionService());
        instance<IRequestAlert>("IRequestAlert", () => new AlertService());
        instance<IRequestTranslation>("IRequestTranslation", () => new TranslationService());
        instance<IRequestNotify>("IRequestNotify", () => new NotifyService());
        instance<IRequestMenuItems>("IRequestMenuItems", () => new MenuService());
        instance<IEmployeeAbsenceService>("IEmployeeAbsenceService", () => new EmployeeAbsenceService());
        instance<IEmployeeService>("IEmployeeService", () => new EmployeeService());
        instance<IAttentionDayService>("IAttentionDayService", () => new AttentionDayService());
        instance<IEmployeeGroupService>("IEmployeeGroupService", () => new EmployeeGroupService());

        // Secondary
        instance<INavigateTo>("INavigateTo", () => new NavigationPlug(() => { throw new Error("Not loaded") }));
        instance<ICanTranslate>("ICanTranslate", () => new TranslationPlug());
        instance<ICanNotify>("ICanNotify", () => new NotifierPlug());
        instance<IAuthenticationRepository>("IAuthenticationRepository", () => new AuthenticationRepository());
        instance<IEventProvider>("IEventProvider", () => new EventPlug());
        instance<IVersionInfoRepository>("IVersionInfoRepository", () => new VersionInfoRepository());
        instance<ILocalRepository>("ILocalRepository", () => new LocalStoragePlug());
        instance<ILocalRepository>("ISessionRepository", () => new SessionStoragePlug());
        instance<IEmployeeAbsenceRepository>("IEmployeeAbsenceRepository", () => new EmployeeAbsenceRepository());
        instance<IEmployeeRepository>("IEmployeeRepository", () => new EmployeeRepository());
        instance<IAttentionDayRepository>("IAttentionDayRepository", () => new AttentionDayRepository());
        instance<IEmployeeGroupRepository>("IEmployeeGroupRepository", () => new EmployeeGroupRepository());

        appDomain.setPortResolver(this.portResolver);
        appDependencies.setPortResolver(this.portResolver);
    }
}
